import { create } from 'zustand';

export const useSubjectPersonGroupStore = create((set, get) => ({
  // State
  groups: [],
  selectedGroup: null,
  loading: false,
  error: null,
  success: null,

  paginationData: {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    totalPages: 0,
    totalItems: 0,
    itemsPerPage: 10,
    hasNextPage: false,
    hasPreviousPage: false
  },

  searchParams: {
    searchTerm: '',
    sortBy: 'createdAt',
    sortDirection: 'desc',
    page: 1,
    pageSize: 10
  },

  columnFilters: {},
  uniqueValues: {},

  formData: {
    name: '',
    description: ''
  },

  isFormOpen: false,
  isEditMode: false,
  isDeleteDialogOpen: false,
  groupToDelete: null,
  selectedGroup: null,

  // Setters for Integration Layer
  setGroups: (groups) => set({ groups }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  setSuccess: (success) => set({ success }),
  setPaginationData: (paginationData) => set({
    paginationData: { ...get().paginationData, ...paginationData }
  }),
  setUniqueValues: (uniqueValues) => set({ uniqueValues }),

  clearMessages: () => set({ error: null, success: null }),

  // UI Actions
  setSearchTerm: (searchTerm) => {
    set({ searchParams: { ...get().searchParams, searchTerm, page: 1 } });
  },

  setSorting: (sortBy, sortDirection) => {
    set({ searchParams: { ...get().searchParams, sortBy, sortDirection, page: 1 } });
  },

  setCurrentPage: (page) => {
    set({ searchParams: { ...get().searchParams, page } });
  },

  setPageSize: (pageSize) => {
    set({ searchParams: { ...get().searchParams, pageSize, page: 1 } });
  },

  setColumnFilters: (columnFilters) => set({ columnFilters }),

  setFormData: (formData) => {
    set({ formData: { ...get().formData, ...formData } });
  },

  resetFormData: () => {
    set({ formData: { name: '', description: '' } });
  },

  openCreateForm: () => {
    set({
      isFormOpen: true,
      isEditMode: false,
      formData: { name: '', description: '' },
      error: null,
      success: null
    });
  },

  openEditForm: (group) => {
    set({
      isFormOpen: true,
      isEditMode: true,
      formData: {
        name: group.name || '',
        description: group.description || ''
      },
      selectedGroup: group,
      error: null,
      success: null
    });
  },

  closeForm: () => {
    set({
      isFormOpen: false,
      isEditMode: false,
      formData: { name: '', description: '' },
      selectedGroup: null,
      error: null,
      success: null
    });
  },

  openDeleteDialog: (group) => {
    set({ isDeleteDialogOpen: true, groupToDelete: group });
  },

  closeDeleteDialog: () => {
    set({ isDeleteDialogOpen: false, groupToDelete: null });
  },
}));

export default useSubjectPersonGroupStore;
